<template>
    <v-container fluid>
        <v-sheet color="dark" class="pa-3" v-if="get_loading">
            <v-skeleton-loader class="mx-auto" max-width="100vw" type="card"></v-skeleton-loader>
        </v-sheet>
        <v-row v-else>
            <v-col cols="12" sm="12">
                <v-card elevation="0" outlined class="w-100">
                    <v-card-title class="d-flex align-center">
                        <label>Departments of: <v-chip>{{ get_company.name }}</v-chip></label>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" @click.stop="add_folder = true">
                            <v-icon class="mr-1">mdi-plus</v-icon>
                            Add Department
                        </v-btn>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="md-5">
                        <v-toolbar color="dark" dark flat>
                            <v-tabs v-model="tab" align-with-title show-arrows>
                                <v-tabs-slider color="yellow"></v-tabs-slider>
                                <v-tab v-for="(item, index) in get_folders" :key="item.id || index">
                                    {{ item.folder_name }}
                                </v-tab>
                            </v-tabs>
                        </v-toolbar>
                        <v-tabs-items v-model="tab" class="scrollable-tabs">
                            <v-tab-item v-for="(item, index) in get_folders" :key="item.id || index">
                                <v-btn color="secondary" class="mt-2" @click.stop="content = false" outlined
                                    style="color: #1976d2 !important">
                                    <v-icon class="mr-1">mdi-plus</v-icon>
                                    add page
                                </v-btn>
                                <v-card flat v-for="(iitem, iindex) in item.files" :key="iindex" elevation="0" outlined
                                    class="my-5 py-4" v-show="content && !edit_page_mode">
                                    <v-card-title class="py-4">
                                        <small>{{ iitem.id }}.) {{ iitem.name }}</small>
                                        <v-spacer />
                                        <v-btn icon @click.stop="deletePage(iitem)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn icon @click.stop="editPage(iitem)">
                                            <v-icon class="mr-2">mdi-pen</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                    <v-divider class="mb-3" />
                                    <v-card-text class="pa-4">
                                        <label v-html="iitem.file_location"></label>
                                    </v-card-text>
                                </v-card>
                                <!-- add page -->
                                <v-card class="py-4" v-show="!content">
                                    <v-divider />
                                    <v-card-text class="mt-5">
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Title</label>
                                                <v-text-field v-model="name" outlined dense></v-text-field>
                                                <label>Content</label>
                                                <wysiwyg v-model="file_location" />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn @click="
                                            content = true;
                                        file.name = null;
                                        file.file = null;
                                        " outlined>Cancel</v-btn>
                                        <v-btn @click="addFile(item)" color="primary">create</v-btn>
                                    </v-card-actions>
                                </v-card>
                                <!-- edit page-->
                                <v-card v-show="edit_page_mode" class="py-4">
                                    <v-divider />
                                    <v-card-text class="mt-5">
                                        <v-row>
                                            <v-col cols="12">
                                                <label>Title</label>
                                                <v-text-field v-model="get_edit_page.name" outlined
                                                    dense></v-text-field>
                                                <label>Content</label>
                                                <wysiwyg v-model="get_edit_page.file_location" />
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn @click="edit_page_mode = false" outlined>Cancel</v-btn>
                                        <v-btn @click="updateFile(get_edit_page)" color="primary">Update</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- add folder modal -->
        <v-dialog v-model="add_folder" persistent max-width="500">
            <v-card class="py-4">
                <v-card-title>
                    <small>Add Department</small>
                    <v-spacer />
                    <v-btn icon @click.stop="add_folder = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="mt-5">
                            <label>Department</label>
                            <v-text-field v-model="folder_name" outlined dense
                                @keydown.enter="addFolder"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="
                        add_folder = false;
                    folder_name = null;
                    " outlined>Cancel</v-btn>
                    <v-btn @click="addFolder" color="primary">create</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- delete a page -->
        <v-dialog v-model="to_delete_mode" persistent max-width="290">
            <v-card>
                <v-card-title>
                    <small>You are about to delete a page</small>
                </v-card-title>
                <v-card-text>Are you sure about this?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="to_delete_mode = false">
                        Cancel
                    </v-btn>
                    <v-btn color="red" dark @click.stop="deletePageProceed">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
/**getters */
import { mapGetters } from "vuex";

export default {
    name: "DocumentComponent",
    data: () => ({
        add_folder: false,
        folder_name: null,
        add_file: false,
        selected_card: null,
        file: {
            file: null,
            name: null,
        },
        file_location: null,
        name: null,
        tab: null,
        content: true,
        edit_page_mode: false,
        to_delete_mode: false,
    }),
    created() { },
    async mounted() {
        document.title = "DG Tasks - Document & SOP";
        await this.getFolders();
    },
    computed: {
        ...mapGetters({
            get_folders: "document/get_folders",
            get_loading: "document/get_loading",
            get_company: "companies/get_selected_company",
            get_edit_page: "document/get_edit_page",
        }),
    },
    methods: {
        showSnackBar(message) {
            this.$store.commit(
                "auth/setMessage",
                { show: true, message: message },
                { root: 1 }
            );
        },
        async addFolder() {
            try {
                const tp = {
                    company_id: this.get_company.id,
                    folder_name: this.folder_name,
                };
                await this.addFolderAPI(tp);
                this.add_folder = false;
                this.folder_name = null;
                this.showSnackBar("adding department, successful!");
            } catch (error) {
                console.log("error on adding folder - component layer", error);
            }
        },
        addFileTrigger(id) {
            this.selected_card = id;
            this.add_file = true;
        },
        handleFileSelect(file) {
            if (file) {
                this.file.file = file;
                console.log("Selected file:", file);
            } else {
                console.error("No file selected");
            }
        },
        async addFile(item) {
            try {
                const tp = {
                    document_id: item.id,
                    file_location: this.file_location,
                    name: this.name,
                };
                await this.addFileAPI(tp);
                this.content = true;
                this.file_location = null;
                this.name = null;
                this.showSnackBar("adding page, successful!");
            } catch (error) {
                console.log("error on uploading file - component level", error);
            }
        },
        deletePage(item) {
            this.setEditPage(item);
            this.to_delete_mode = true;
        },
        async deletePageProceed() {
            try {
                await this.deletePageAPI(this.get_edit_page.id);
                await this.getFolders();
                this.to_delete_mode = false;
            } catch (error) {
                console.log("error on delete page - component layer", error);
            }
        },
        editPage(item) {
            this.setEditPage(item);
            this.edit_page_mode = true;
        },
        async updateFile(item) {
            try {
                const tp = {
                    name: item.name,
                    file_location: item.file_location,
                };
                await this.updateFileAPI(tp, item.id);
                await this.getFolders();
                this.edit_page_mode = false;
            } catch (error) {
                console.log("error on updating page - component layer", error);
            }
        },

        // Moved from document.service.js
        /**
         * add folder
         * @params
         * - int?: company_id,
         * - string?: folder_name
         */
        async addFolderAPI(data) {
            try {
                await this.$axios.post("/api/documents/folder", data);
                this.getFolders();
            } catch (error) {
                console.log("error on adding folder - service layer", error);
            }
        },

        /**
         * @params
         * id?: company_id
         */
        async getFolders() {
            try {
                const company_id = this.$store.getters["companies/get_selected_company"];
                const response = await this.$axios.get(
                    `/api/documents/folder/getFolder/${company_id.id}`
                );
                const { data } = response;
                this.$store.commit("document/set_folder", data);
                this.$store.commit("document/set_loading", false);
            } catch (error) {
                console.log("error on fetching folders - service layer", error);
            }
        },

        /**
         * add a file
         * @params
         * data: object
         * - document_id?: int
         * - file_location?: string
         * - name?: string
         */
        async addFileAPI(item) {
            try {
                await this.$axios.post("/api/documents/files", item);
                this.getFolders();
            } catch (error) {
                console.log("adding file error - service layer", error);
            }
        },

        /**
         * set edit page
         * @params
         * item?: object
         */
        setEditPage(item) {
            try {
                this.$store.commit("document/set_edit_page", item);
            } catch (error) {
                console.log("there's an error assigning to be edit page", error);
            }
        },

        /**
         * update file
         * @params
         * -item?: object,
         * -id?: number
         */
        async updateFileAPI(item, id) {
            try {
                await this.$axios.patch(`/api/documents/files/${id}`, item);
                return true;
            } catch (error) {
                console.log("error on update page - service layer", error);
            }
        },

        /**
         * delete a page
         * @params
         * -int?: number
         */
        async deletePageAPI(id) {
            try {
                await this.$axios.delete(`/api/documents/files/${id}`);
            } catch (error) {
                console.log("error on delete page - service layer", error);
            }
        },
    },
    watch: {},
};
</script>

<style scoped>
.scrollable-list {
    max-height: 300px;
    overflow-y: auto;
}

.file-list {
    max-height: 300px;
    overflow-y: auto;
    border-radius: 8px;
}

.file-list-item {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 8px 16px;
}

.file-list-item:last-child {
    border-bottom: none;
}

.scrollable-tabs {
    max-height: 85vh;
    overflow-y: auto;
}
</style>
